import React, { useEffect, useState } from "react";
import axios from "axios";
import { Modal, Spin } from "antd";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { BASE_URL } from "../../Constants";
import { PLATFORMS } from "../publicEmployees/socialPlatforms";

// Read-only view for a parent company's admin. Each sub-company edits its own links in Settings.
const SubCompanySocialLinksModal = ({ company, onClose }) => {
  const { t } = useTranslation();
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    let isCurrent = true;
    axios
      .get(`${BASE_URL}/Company/settings?id=${company.id}`)
      .then((res) => {
        if (isCurrent) setSettings(res.data);
      })
      .catch(() => {
        toast.error(t("settings.socialLinks.loadFailed"));
        onClose();
      });
    return () => {
      isCurrent = false;
    };
    // Loads once per opening; the modal is mounted fresh for each company.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [company.id]);

  const ownLinks = settings?.socialLinks || [];
  const usingParentLinks = ownLinks.length === 0;
  const links = usingParentLinks ? settings?.inheritedSocialLinks || [] : ownLinks;

  return (
    <Modal
      open
      title={`${t("settings.socialLinks.title")}: ${company.name}`}
      onCancel={onClose}
      footer={null}
    >
      {!settings ? (
        <div className="flex justify-center py-6">
          <Spin />
        </div>
      ) : links.length === 0 ? (
        <p className="text-sm text-gray-500">{t("settings.socialLinks.noneSet")}</p>
      ) : (
        <>
          {usingParentLinks && (
            <p className="text-sm text-gray-700 mb-3">{t("settings.socialLinks.usingParentView")}</p>
          )}
          <ul className="space-y-2">
            {links.map((link) => {
              const platform = PLATFORMS.find((p) => p.key === link.platform);
              const Icon = platform?.Icon;
              return (
                <li key={link.platform} className="flex items-center gap-2 text-sm">
                  {Icon && <Icon aria-hidden="true" className="text-lg w-6" style={{ color: platform.color }} />}
                  <a
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 hover:underline break-all"
                  >
                    {link.url}
                  </a>
                </li>
              );
            })}
          </ul>
        </>
      )}
    </Modal>
  );
};

export default SubCompanySocialLinksModal;
